import { LinkStyles } from "@at/design-system-elements";
import { ThemeSelectors, TypeFiesta } from "@at/design-system-foundation";
import styled, { css } from "styled-components";

import {
  IDescriptionListDataProps,
  IDescriptionListStyledProps,
} from "./description-list.types";
import { ResetButtonStyles } from "../../../utils/styles/buttons.styles";
import { PrintStyleSheet } from "../../seller/advert-seller-details/location/location.styles";

const truncateText = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 50%;
`;

const compactText = css`
  text-align: left;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: fit-content;
  padding-right: 16px;
`;

const sharedTermDetailStyles = css`
  padding: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)} 0;
  flex: 1;
`;

export const DescriptionListWrapper = styled.section<IDescriptionListStyledProps>`
  margin: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)} 0;

  @media (min-width: ${({ minWidthColumnSplit }) => minWidthColumnSplit}) {
    display: grid;
    grid-template-columns: ${({ columnCount, maxColumnWidth }) =>
      `repeat(${columnCount}, minmax(0, ${maxColumnWidth}))`};
    justify-content: ${({ justifyGridContent }) => justifyGridContent};
    gap: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  }

  @media (min-width: 64rem) {
    gap: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};
  }

  @media print {
    display: grid;
    grid-template-columns: ${({ columnCount, maxColumnWidth }) =>
      `repeat(${columnCount}, minmax(0, ${maxColumnWidth}))`};
    justify-content: ${({ justifyGridContent }) => justifyGridContent};
    gap: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
    margin: 0;
  }
`;

export const Column = styled.dl`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
`;

export const Row = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid ${({ theme }) => ThemeSelectors.getGrey(theme)};
  display: flex;
  min-height: 2.5rem;
`;

export const Term = styled(TypeFiesta).attrs({
  as: "span",
})<IDescriptionListDataProps>`
  ${sharedTermDetailStyles};
  ${({ shouldTruncate = true }) => shouldTruncate && truncateText};
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  font-variation-settings: "wght" 400;
  ${({ compact }) => compact && compactText}
`;
export const Details = styled(TypeFiesta).attrs({
  as: "span",
})<IDescriptionListDataProps>`
  ${sharedTermDetailStyles};
  ${({ shouldTruncate }) => shouldTruncate && truncateText};
  color: ${({ theme }) => ThemeSelectors.getCopyColor(theme)};
  display: flex;
  justify-content: flex-end;
  text-align: right;
  ${({ compact }) => compact && compactText}
`;

export const InfoButtonStyled = styled(ResetButtonStyles)`
  ${({ theme }) => LinkStyles(theme)};
  border: none;
  padding-left: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${PrintStyleSheet}

  svg,
  path {
    fill: currentColor;
    position: relative;
  }
`;

export const ModalBody = styled.div`
  h2 {
    margin-bottom: ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)};
  }
  p {
    color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  }
`;
